import React, { useState, useEffect } from 'react';
// import cn from 'classnames';

import ProgressBar from '../ProgressBar/ProgressBar';
import SelectYesNo from '../SelectYesNo/SelectYesNo';
import ImportantNote from './ImportantNote';
import styles from './Steps.module.css';

const Step12 = (props) => {
  const { 
    onSave, 
    stepsData, 
  } = props;

  const [diseases, setDiseases] = useState(stepsData.chronic_diseases);
  const [showDiseases, setShowDiseases] = useState();
  const [showNote, setShowNote] = useState(false);

  useEffect(() => {
    let showDiseases = null;
    if (stepsData.chronic_diseases !== undefined) {
      showDiseases = !!stepsData.chronic_diseases;
    }
    setShowDiseases(showDiseases);
  }, [stepsData]);

  const onChangeHandler = (value) => {
    setShowDiseases(value);
  };

  const onFinishSave = () => {
    let chronicDiseases = showDiseases ? diseases : '';

    onSave({ 
      chronic_diseases: chronicDiseases || '',
    });
  };

  const onSaveHandler = () => {
    if (showDiseases && diseases) {
      return setShowNote(true);
    }

    onFinishSave();
  };

  if (showNote) {
    return (
      <ImportantNote
        className={styles.diseasesImportantNote}
        message="Meal plans for people with health conditions will be available in the next version of the app. Meanwhile, consult with your doctor if our meal plan works for you."
        onClick={onFinishSave}
      />
    );
  }

  return (
    <div className={styles.stepWrapper}>
      <ProgressBar />
      <div className={styles.diseasesContent}>
        <div className={styles.stepHeader}>
          Do you have any chronic diseases we should be aware about?
        </div>
        <SelectYesNo 
          onChange={onChangeHandler}
          defaultValue={showDiseases}
        />
        {showDiseases && (
          <div className={styles.inputWrapper}>
            <input 
              type="text"
              className={styles.input}
              value={diseases}
              onChange={(e) => setDiseases(e.target.value)}
              placeholder="Enter diseases"
            />
          </div>
        )}
        <button
          className="green-button"
          onClick={onSaveHandler}
          disabled={showDiseases === undefined}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Step12;